
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Location } from "@/types/location";

interface EditLocationDialogProps {
  location: Location | null;
  onClose: () => void;
  onSave: () => void;
  onChange: (location: Location) => void;
}

export function EditLocationDialog({
  location,
  onClose,
  onSave,
  onChange,
}: EditLocationDialogProps) {
  if (!location) return null;

  return (
    <Dialog open={!!location} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar Localização</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Nome</Label>
            <Input
              id="name"
              value={location.name}
              onChange={(e) =>
                onChange({
                  ...location,
                  name: e.target.value,
                })
              }
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="description">Descrição</Label>
            <Input
              id="description"
              value={location.description || ''}
              onChange={(e) =>
                onChange({
                  ...location,
                  description: e.target.value,
                })
              }
            />
          </div>

          <div className="flex items-center space-x-2">
            <Switch
              id="active"
              checked={location.active}
              onCheckedChange={(checked) =>
                onChange({
                  ...location,
                  active: checked,
                })
              }
            />
            <Label htmlFor="active">Ativo</Label>
          </div>

          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button onClick={onSave}>Salvar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
